import { useFormatNumber } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { BTLCalcAccordionBlock } from './BTLCalcAccordionBlock'
import {
  FIELD_PROPS,
  formatOptionsDecimal0,
  formatOptionsDecimal2,
  HorizontalLine2,
  HorizontalLine3,
  SimpleInputSmallMargin,
} from './BTLCalcUtil'

export const BTLCalcBlock2: FunctionComponent<
  React.PropsWithChildren<{
    putDownValue: number
    propertyTax: number
    notaryFees: number
    agentFees: number
    interestRate: number
    purchaseCosts: number
    mortgagePayment: number
    repaymentRate: number
    loanSize: number
    minimumDownpayment: number
  }>
> = (props) => {
  const {
    putDownValue,
    propertyTax,
    notaryFees,
    agentFees,
    interestRate,
    purchaseCosts,
    mortgagePayment,
    repaymentRate,
    loanSize,
    minimumDownpayment,
  } = props
  const formatAbsolute = useFormatNumber(formatOptionsDecimal0)
  const formatPercentage = useFormatNumber(formatOptionsDecimal2)

  return (
    <BTLCalcAccordionBlock
      title={'Loan Information, Taxes and additional Costs'}
    >
      <div className="flex flex-row pt-px-12">
        <div className="flex-1">
          <SimpleInputSmallMargin
            label={'Equity Capital'}
            value={formatAbsolute(putDownValue) + ' EUR'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'numeric' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="flex-1 ml-px-20">
          <SimpleInputSmallMargin
            label={'Property Transfer Tax'}
            value={formatPercentage(propertyTax) + '%'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'decimal' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
      </div>
      <div className="flex-1 flex flex-row mt-px-24">
        <div className="flex-1">
          <SimpleInputSmallMargin
            label={'Notary Fees'}
            value={formatPercentage(notaryFees) + '%'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'decimal' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="flex-1 ml-px-24">
          <SimpleInputSmallMargin
            label={'Real Estate Agent Fees'}
            value={formatPercentage(agentFees) + '%'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'decimal' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
      </div>

      <div className="flex flex-row mt-px-24">
        <div className="flex-1">
          <SimpleInputSmallMargin
            label={'Interest Rate of'}
            value={formatPercentage(interestRate) + '%'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'decimal' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="flex-1 ml-px-24">
          <SimpleInputSmallMargin
            label={'Repayment Rate'}
            value={formatPercentage(repaymentRate) + '%'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'decimal' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
      </div>

      <HorizontalLine2 />
      <div className="flex flex-row">
        <div className="flex-1 mt-px-20 text-[16px]">
          Total Purchase Costs
          <br />
          <span className="font-semibold">
            {formatAbsolute(purchaseCosts) + ' EUR'}
          </span>
        </div>
        <div className="flex-1 mt-px-20 ml-px-20 text-[16px]">
          Loan Size
          <br />
          <span className="font-semibold">
            {formatAbsolute(loanSize) + ' EUR'}
          </span>
        </div>
      </div>
      <div className="flex flex-row">
        <div className="flex-1 mt-px-20 text-[16px]">
          Annual mortgage payment
          <br />
          <span className="font-semibold">
            {formatAbsolute(mortgagePayment) + ' EUR'}
          </span>
        </div>
        <div className="flex-1 mt-px-20 ml-px-20 text-[16px]">
          Minimum downpayment for non-residents
          <br />
          <span className="font-semibold">
            {formatAbsolute(minimumDownpayment) + ' EUR'}
          </span>
        </div>
      </div>

      <br />
      <HorizontalLine3 />
    </BTLCalcAccordionBlock>
  )
}
